import { render, staticRenderFns } from "./AAppointmentLabel.vue?vue&type=template&id=4bcb3ce8&scoped=true"
import script from "./AAppointmentLabel.vue?vue&type=script&lang=js"
export * from "./AAppointmentLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb3ce8",
  null
  
)

export default component.exports